import React from 'react';

export const Footer = () => {
  const styles = {
    color: '#CCC',
    position: 'relative',
    padding: '4em',
    fontFamily: 'Arial',
    fontSize: '85%',
    textAlign: 'center'
  };
  const iconStyles = {
    marginLeft: '.1em',
    marginRight: '.1em'
  };
  return (
    <footer style={styles}>
      made with <i className="fas fa-heart" style={iconStyles} /> by David
      Vandenbogaerde ©2019 - 2022
    </footer>
  );
};
